import { Box } from "@mui/material";
import React from "react";
import NewCompany from "./Components/NewCompany"
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2,}} className={classes.indexBox}>
      <NewCompany />
    </Box>
  );
};

export default Category;
